exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".help-documentation-modal .modal-dialog {\n  position: fixed;\n  top: 55px;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  max-width: 400px;\n  margin: 0;\n}\n.help-documentation-modal .modal-body {\n  padding: 0;\n}\n.help-documentation-modal .modal-content {\n  border: none;\n  border-radius: none;\n  height: calc(100vh - 55px);\n  padding: 0;\n}\n.help-documentation-modal .modal-content iframe {\n    width: 100%;\n    height: calc(100vh - 55px);\n    border: none;\n}\n", ""]);

// exports
